<template>
  <va-create-layout>
    <sliders-form :title="title" :item="item"></sliders-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
